import SettingsExpertTeamMemberEditModalModule from './team-member-edit-modal.module'

export default SettingsExpertTeamMemberEditModalModule
